import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
    sticky: {
        color: {
            lg: '#fff'
        },
        borderLeft: {
            lg: '0 solid important'
        },
        borderRight: {
            lg: '0 solid important'
        },
        position: {
            lg: 'sticky'
        },
        left: {
            lg: '0'
        },
        top: {
            lg: '0'
        },
        backgroundColor: {
            lg: '#7f7f7f'
        },
        padding:'3px 7px'
    },
    base: {
        padding:'3px 7px'
    }
}